/**
 * 상점 바로머니 > 일별 상세 조회 폼 데이터
 */
export class FormDataGetStoreBaromoneyDailyDetail {
    /** 허브 아이디 */
    selectedHubId = '';
    /** 상점 아이디 */
    selectedStoreId = '';
    /** 기간 */
    date = [];
    /** 접수번호 */
    orderNumber = '';
    constructor(data) {
        if (!data) {
            return;
        }
        Object.assign(this, data);
    }
}
